var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tipoDocumento,
                  expression: "form.tipoDocumento"
                }
              ],
              attrs: { type: "radio", value: "ND" },
              domProps: { checked: _vm._q(_vm.form.tipoDocumento, "ND") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "tipoDocumento", "ND")
                  },
                  _vm.changeTipoDocumento
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Nota de Débito")])
          ]),
          _vm._v(" "),
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tipoDocumento,
                  expression: "form.tipoDocumento"
                }
              ],
              attrs: { type: "radio", value: "NC" },
              domProps: { checked: _vm._q(_vm.form.tipoDocumento, "NC") },
              on: {
                change: [
                  function($event) {
                    return _vm.$set(_vm.form, "tipoDocumento", "NC")
                  },
                  _vm.changeTipoDocumento
                ]
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Nota de Crédito")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  placeholder: "Seleccione...",
                  id: "motivo",
                  options: _vm.motivos,
                  label: "descripcion"
                },
                on: { input: _vm.inputMotivo },
                model: {
                  value: _vm.selectedMotivo,
                  callback: function($$v) {
                    _vm.selectedMotivo = $$v
                  },
                  expression: "selectedMotivo"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "motivo" } }, [_vm._v("Motivo")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  id: "ruta",
                  options: _vm.rutas,
                  label: "descripcion",
                  placeholder: "Seleccione..."
                },
                on: { search: _vm.onSearchRutas, input: _vm.inputRuta },
                model: {
                  value: _vm.selectedRuta,
                  callback: function($$v) {
                    _vm.selectedRuta = $$v
                  },
                  expression: "selectedRuta"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ruta" } }, [_vm._v("Ruta")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("VueCtkDateTimePicker", {
                attrs: {
                  id: "fecha",
                  locale: "es",
                  "no-label": "",
                  "button-now-translation": "Ahora",
                  format: "YYYY-MM-DD HH:mm",
                  formatted: "YYYY-MM-DD HH:mm",
                  label: "Seleccione fecha..."
                },
                model: {
                  value: _vm.form.fecha,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha", $$v)
                  },
                  expression: "form.fecha"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha")])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "observacion", placeholder: "" },
                model: {
                  value: _vm.form.observacion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "observacion", $$v)
                  },
                  expression: "form.observacion"
                }
              },
              [_vm._v("\n\t\t\t\t\t\tObservación\n\t\t\t\t\t")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "valor",
                  placeholder: "Escriba un valor...",
                  vMoney: "",
                  format: _vm.money
                },
                model: {
                  value: _vm.form.valor,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "valor", $$v)
                  },
                  expression: "form.valor"
                }
              },
              [_vm._v("\n\t\t\t\t\t\tValor\n\t\t\t\t\t")]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _c("span", [_vm._v("Guardar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Movimiento")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4379b9a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4379b9a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/NotaDebitoCredito.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4379b9a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/NotaDebitoCredito.vue
// module chunks = 0